import api from "@/config/http-client-gateway";
import { showErrorToast } from '@/kernel/alerts';
import { getToken } from "@/kernel/utils";

export const createSection = async (dataForm) => {
    try {
        const { data } = await api.doPost('/create-section', dataForm);
        return data;
    } catch (error) {
        showErrorToast("No se pudo crear la sección");
        return error;
    }
}

export const getSectionByPageandlanguage = async (params) => {
    try {
        const { data } = await api.doGet('/section', { params });
        return data;
    } catch (error) {
        if (getToken()) {
            showErrorToast("No se pudo obtener la sección");
        }
        return error;
    }
}

export const updateSection = async (dataForm) => {
    try {
        const { data } = await api.doPut('/update-section', dataForm);
        return data;
    } catch (error) {
        showErrorToast("No se pudo actualizar la sección");
        return error;
    }
}

export const updateSectionImage = async (dataForm) => {
    try {
        const { data } = await api.doPutFormData('/image-update', dataForm); 
        return data;
    } catch (error) {
        showErrorToast("No se pudo actualizar la imagen de la sección");
        return error;
    }
}

export const getImageBySection = async (params) => {
    try {
        const { data } = await api.doGet('/images-by-section', { params });
        return data;
    } catch (error) {
        if (getToken()) {
            showErrorToast("No se pudo obtener la imagen de la sección");
        }
        return error;
    }
}